module.exports = __webpack_public_path__ + "img/button_reload_dark.c37f9b88.png";